// extracted by mini-css-extract-plugin
export default {"bottom-addon":"bottom-addon__fhU3l","divider-paddings":"divider-paddings__T76GN"};